import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import "../../assets/scss/custom/structure/_footer.scss";

const Footer = () => {
  const location = useLocation();

  // Determine the path prefix based on current route
  const getPathPrefix = () => {
    if (location.pathname.startsWith("/admin")) return "/admin";
    if (location.pathname.startsWith("/restaurant")) return "/restaurant";
    return "";
  };

  const pathPrefix = getPathPrefix();
  return (
    <React.Fragment>
      <footer className="app-footer">
        <Container fluid={true}>
          <Row className="align-items-center">
            <Col sm={6}>
              <span className="app-footer__text">
                © Copyrights {new Date().getFullYear()} - All Rights Reserved.
              </span>
            </Col>
            <Col sm={6}>
              <div className="app-footer__links text-sm-end">
                <Link
                  to={`${pathPrefix}/privacy-policy`}
                  className="app-footer__link"
                >
                  Privacy Policy
                </Link>
                <span className="app-footer__divider">|</span>
                <Link
                  to={`${pathPrefix}/terms-of-service`}
                  className="app-footer__link"
                >
                  Terms &amp; Conditions
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
